// START_MODULE components_atoms_icons_telegramicon_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';

import { IconProps } from './interfaces/iconProps';

const TelegramIcon: React.FC<IconProps> = ({ size = 200, color = 'currentColor', ...restProps }) => (
  <svg {...restProps} fill={color} height={`${size}px`} width={`${size}px`} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 189.473 189.473" xmlSpace="preserve">
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <g>
        <path
          d="M152.531,179.476c-1.48,0-2.95-0.438-4.211-1.293l-47.641-32.316l-25.552,18.386c-2.004,1.441-4.587,1.804-6.914,0.972 c-2.324-0.834-4.089-2.759-4.719-5.146l-12.83-48.622L4.821,93.928c-2.886-1.104-4.8-3.865-4.821-6.955 c-0.021-3.09,1.855-5.877,4.727-7.02l174.312-69.36c0.791-0.336,1.628-0.53,2.472-0.582c0.302-0.018,0.605-0.018,0.906-0.001 c1.748,0.104,3.465,0.816,4.805,2.13c0.139,0.136,0.271,0.275,0.396,0.42c1.11,1.268,1.72,2.814,1.835,4.389 c0.028,0.396,0.026,0.797-0.009,1.198c-0.024,0.286-0.065,0.571-0.123,0.854L159.898,173.38c-0.473,2.48-2.161,4.556-4.493,5.523 C154.48,179.287,153.503,179.476,152.531,179.476z M104.862,130.579l42.437,28.785L170.193,39.24l-82.687,79.566l17.156,11.638 C104.731,130.487,104.797,130.533,104.862,130.579z M69.535,124.178l5.682,21.53l12.242-8.809l-16.03-10.874 C70.684,125.521,70.046,124.893,69.535,124.178z M28.136,86.782l31.478,12.035c2.255,0.862,3.957,2.758,4.573,5.092l3.992,15.129 c0.183-1.745,0.974-3.387,2.259-4.624L149.227,38.6L28.136,86.782z"
          color={color}
        />
      </g>
    </g>
  </svg>
);

export default TelegramIcon;

// END_MODULE components_atoms_icons_telegramicon_tsx
